<template>
    <div class="wrapper">
        <div style="margin: 80px 0;">
            <div style="display: flex;justify-content: center;">
                <el-checkbox-group v-model="checkList">
                    <el-checkbox v-for="(item, index) in Items" :key="index" :label="item"></el-checkbox>
                </el-checkbox-group>
            </div>
            <div style="margin-top: 20px;display: flex;justify-content: center;">
                <el-button type="primary">
                    Download Excel
                </el-button>
            </div>
        </div>
        <div style="margin: 80px 0;">
            <el-upload ref="upload" class="upload-demo" drag action="" :before-upload="beforeUpload"
                :on-change="handleFileChange" :on-remove="handleRemove" :file-list="fileList" :auto-upload="false"
                accept=".xls,.xlsx" :limit="1">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">Click or drag the file to this area</div>
                <div class="el-upload__tip" slot="tip">
                    <div style="font-size: 14px;">Only <span style="color: #CA141D;">.xls</span> and <span
                            style="color: #CA141D;">.xlsx</span> files are supported</div>
                    <div style="margin-top: 20px;">
                        <el-button type="primary" :disabled="!fileList.length || isUploading" @click="handleUpload">
                            Upload
                        </el-button>
                        <el-button type="danger" :disabled="!fileList.length || isUploading" @click="handleCancel">
                            Cancel
                        </el-button>
                    </div>
                    <div style="margin-top: 20px;">
                        <el-progress v-if="uploadProgress > 0 && uploadProgress < 100" :percentage="uploadProgress">
                        </el-progress>
                        <el-progress v-else-if="uploadProgress === 100" :percentage="100" status="success">
                        </el-progress>
                    </div>

                </div>
            </el-upload>
        </div>

    </div>
</template>
  
<script>
export default {
    data() {
        return {
            fileList: [], // 文件列表
            Items: [],
            checkList: [],
            isUploading: false, // 上传状态变量
            uploadProgress: 0 // 用于显示上传进度的百分比
        };
    },
    mounted() {
        this.getfenlei()
    },
    methods: {
        getfenlei() {
            this.Items = [],
                this.$axios
                    .post("/api/mall/orderSub/getSearchParams")
                    .then(res => {
                        this.Items = res.data.data
                    })
                    .catch(err => {
                        return Promise.reject(err);
                    });
        },
        // 上传前检查文件类型
        beforeUpload(file) {
            const isExcel = file.type === 'application/vnd.ms-excel' || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            if (!isExcel) {
                this.$message.error('Only .xls and .xlsx files are supported');
            }
            return isExcel; // 只有通过验证的文件才能被添加
        },
        // 文件选择或拖拽后处理
        handleFileChange(file, fileList) {
            this.fileList = fileList;
        },
        // 移除文件
        handleRemove(file, fileList) {
            this.fileList = fileList;
        },
        // 上传文件到后端
        handleUpload() {
            const formData = new FormData()
            formData.set('file', this.fileList[0].raw)
            formData.set('userId', this.$store.getters.getUser.id)
            this.isUploading = true; // 开始上传时禁用按钮
            this.$axios.post("/api/mall/orderSub/saveImport", formData, {
                onUploadProgress: progressEvent => {
                    // 计算上传的进度百分比
                    this.uploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                }
            })
                .then(res => {
                    if (res.data.code === 200) {
                        this.list = res.data.data;
                        this.$message.success('File uploaded');
                        this.fileList = [];
                    } else {
                        this.$alert(res.data.message, {
                            confirmButtonText: 'OK'
                        });
                        this.fileList = [];
                    }
                    // 重置上传进度
                    this.uploadProgress = 0;
                })
                .catch(err => {
                    this.uploadProgress = 0;
                    return Promise.reject(err);
                })
                .finally(() => {
                    this.isUploading = false; // 上传完成或失败后解禁按钮
                    this.uploadProgress = 0;
                });
        },
        // 取消上传
        handleCancel() {
            this.fileList = [];
            this.isUploading = false;
            this.$message.info('Upload cancelled');
        }
    }
};
</script>
  
<style scoped>
.wrapper {
    width: 1280px;
    margin: 0 auto;
    color: #000;
}

.upload-demo {
    border: 2px dashed #d9d9d9;
    border-radius: 6px;
    background-color: #fafafa;
    text-align: center;
    padding: 40px;
}
</style>
  